export default {
  install(app) {
    const gsc = {
      inited: false,
      openWidget(widgetId) {
        window.gsc('show', widgetId)
      },
      closeWidget(widgetId) {
        window.gsc('close', widgetId)
      },
      setParams(params) {
        window.gsc('params', params)
      },
      async init(gscSettings) {
        window.gsc =
          window.gsc ||
          function () {
            ;(window.gsc.q = window.gsc.q || []).push(arguments)
          }
        if (!this.inited) {
          await this.loadScript(gscSettings)
          this.setParams({
            name: gscSettings.name,
            email: gscSettings.email,
            user_id: gscSettings.userId
          })
          this.inited = true
        }
      },
      loadScript({ gscId }) {
        return new Promise((resolve) => {
          const script = document.createElement('script')
          script.async = true
          script.src = `https://l.getsitecontrol.com/${gscId}.js`
          script.onload = resolve
          document.body.appendChild(script)
        })
      }
    }

    app.config.globalProperties.$gsc = gsc
    app.provide('gsc', gsc)
  }
}
